/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { ModalData, useAccounts, userColumns } from 'features/home';
import { Datagrid } from 'components/Datatable';
import Loader from 'components/Loader/Loader';

import LocaleStorageService from 'services/LocaleStorageService';

import { LOGIN_ROUTE } from 'routes/core/RouterConstants';

const HomePage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [accountsData, setAccountsData] = useState(null);
  const navigate = useNavigate();

  const { getDispatchAccounts, isAccountsFetching } = useAccounts();

  const handleModalOpener = () => {
    setIsOpenModal((state) => !state);
  };

  useEffect(() => {
    if (LocaleStorageService.get('key')) {
      getDispatchAccounts()
        .unwrap()
        .then((response) => setAccountsData(response))
        .catch((error) => {
          if (error.status === 403) {
            navigate(LOGIN_ROUTE);
            toast.error('Forbidden');
          }
        });
    }
  }, [isAccountsFetching]);

  if (accountsData === null) return <Loader />;
  else
    return (
      <div>
        <ModalData
          title="Add Account"
          isOpen={isOpenModal}
          onClose={handleModalOpener}
        />
        <Datagrid
          data={accountsData?.items}
          columnShape={userColumns}
          onAdd={handleModalOpener}
          hasToolbar
        />
      </div>
    );
};

export default HomePage;
